import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import helpercontextmenu from "../../../../assets/images/docs/helper/context-menu.png";
import helpericon from "../../../../assets/images/docs/helper/helpericon.png";
import helperbutton from "../../../../assets/images/docs/helper/button.png";
import helperbutton2 from "../../../../assets/images/docs/helper/button2.png";
import browserextension from "../../../../assets/images/docs/browserextension.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  helpercontextmenu,
  helpericon,
  helperbutton,
  helperbutton2,
  browserextension,
  React
};